/**
 * Keep cart sticky + summary totals locked to live /cart.js.
 * CTA is pinned "Afrekenen" / "Checkout". No staffel tease.
 * Does not intercept checkout clicks.
 * tl=cartchk0914b
 */
(function () {
  if (window.__tlCartTotalSync19) return;
  window.__tlCartTotalSync19 = true;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return '€' + ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',');
    }
  }

  function guestCta(isNl) {
    return isNl ? 'Afrekenen' : 'Checkout';
  }

  function apply(cart) {
    if (!cart) return;
    var cents = cart.total_price;
    var count = cart.item_count;
    var formatted = money(cents, cart.currency);
    var isNl = ((document.documentElement.lang || '').toLowerCase().indexOf('nl') === 0)
      || (location.pathname || '').indexOf('/nl') === 0;
    var i18n = window.__tlCartI18n || {};
    var itemWord = count === 1
      ? (i18n.itemOne || (isNl ? 'artikel' : 'item'))
      : (i18n.itemOther || (isNl ? 'artikelen' : 'items'));
    var totalWord = i18n.totalPrefix || (isNl ? 'Totaal' : 'Total');
    var label = totalWord + ' · ' + count + ' ' + itemWord;
    var cta = guestCta(isNl);

    document.querySelectorAll('[data-tl-cart-sticky]').forEach(function (el) {
      el.setAttribute('data-tl-cart-cents', String(cents));
      el.setAttribute('data-tl-cart-count', String(count));
      var lab = el.querySelector('[data-tl-cart-label]');
      var price = el.querySelector('[data-tl-cart-money]');
      var btn = el.querySelector('[data-tl-cart-cta]');
      if (lab) lab.textContent = label;
      if (price) price.textContent = formatted;
      if (btn) btn.textContent = cta;
      el.style.display = count === 0 ? 'none' : '';
    });

    document.querySelectorAll('#checkout[data-tl-cart-checkout], a#checkout, a.tl-cart-cta[data-tl-cart-checkout], #CartDrawer-Checkout').forEach(function (el) {
      if (el.disabled || count === 0) return;
      var textEl = el.querySelector('.button-text, .Zt_button_check') || el;
      var current = (textEl.textContent || '').replace(/\s+/g, ' ').trim();
      if (current !== cta) textEl.textContent = cta;
      el.setAttribute('data-tl-cart-cents', String(cents));
    });

    document.querySelectorAll('.tl-cart-summary__now, .totals__total-value.tl-cart-summary__now').forEach(function (el) {
      el.textContent = formatted;
    });

    document.querySelectorAll('.tl-cart-summary__count').forEach(function (el) {
      el.textContent = ' · ' + count + ' ' + itemWord;
    });
  }

  var inflight = null;
  var queued = false;
  function sync() {
    if (inflight) {
      queued = true;
      return inflight;
    }
    inflight = fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(apply)
      .catch(function () {})
      .finally(function () {
        inflight = null;
        if (queued) {
          queued = false;
          sync();
        }
      });
    return inflight;
  }

  function boot() {
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  ['cart:updated', 'cart:refresh', 'cart-drawer:update'].forEach(function (ev) {
    document.addEventListener(ev, sync);
  });
  document.addEventListener('cart:change', sync);

  var obs = new MutationObserver(function () {
    window.clearTimeout(obs._t);
    obs._t = window.setTimeout(sync, 80);
  });
  function watch() {
    var footer = document.getElementById('main-cart-footer');
    if (footer) obs.observe(footer, { childList: true, subtree: true });
  }
  watch();
  document.addEventListener('DOMContentLoaded', watch);

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('cart-remove-button, .quantity__button, [name="updates[]"], .cart-item__quantity')) {
        setTimeout(sync, 400);
        setTimeout(sync, 1200);
      }
    },
    true
  );
})();
